import React from 'react';

export default function ({ color = '#8F9199', size = 19 }: { color?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9.5" r="8.23333" fill="#E0E0E0" stroke="white" strokeWidth="2.53333" />
      <path
        d="M9.74316 12.4308H12.5093"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.376 5.9589C9.69569 5.55159 10.2123 5.57285 10.62 5.89253L11.223 6.36534C11.6307 6.68503 11.7752 7.18082 11.4555 7.589L7.85998 12.1761C7.73983 12.3296 7.55635 12.4203 7.36115 12.4225L5.9744 12.4403L5.66035 11.0891C5.6161 10.8995 5.66035 10.7 5.7805 10.546L9.376 5.9589Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.7041 6.80078L10.7836 8.43088"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
